(() => {
  const $ = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => [...r.querySelectorAll(s)];
  const drawer = $('[data-cart-drawer]');
  const toast = $('#AkaiToast');
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:window.AKAI_CURRENCY||'USD',maximumFractionDigits:2}).format(Number(cents||0)/100);
  const showToast = msg => { if(!toast) return; toast.textContent=msg; toast.classList.add('show'); clearTimeout(window._akaiToast); window._akaiToast=setTimeout(()=>toast.classList.remove('show'),2200); };
  const openCart = () => { if(!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('locked'); };
  const closeCart = () => { if(!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('locked'); };
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',openCart));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click',closeCart));

  function escapeHtml(s=''){return String(s).replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));}
  function cartItemHtml(item){
    const img=item.image?`<img src="${item.image}" alt="${escapeHtml(item.product_title)}" loading="lazy">`:'';
    return `<div class="drawer-item"><a href="${item.url}">${img}</a><div><h3>${escapeHtml(item.product_title)}</h3><p>${escapeHtml(item.variant_title||'')}</p><div class="drawer-item__bottom"><span>${money(item.final_line_price)}</span><div class="qty"><button type="button" data-drawer-minus data-key="${escapeHtml(item.key)}">−</button><span>${item.quantity}</span><button type="button" data-drawer-plus data-key="${escapeHtml(item.key)}">+</button></div></div></div></div>`;
  }
  function renderCart(cart){
    if(!drawer) return;
    $$('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    const body=$('[data-cart-body]');
    if(body) body.innerHTML=cart.item_count ? cart.items.map(cartItemHtml).join('') : `<div class="drawer-empty"><h3>Your bag is empty.</h3><a class="btn btn--dark" href="${window.routes.cart}">SHOP ALL</a></div>`;
    const total=$('[data-cart-total]'); if(total) total.textContent=money(cart.total_price);
    const threshold=Number(document.body.dataset.shippingThreshold||1500)*100;
    const remain=$('[data-shipping-remaining]'), prog=$('[data-shipping-progress]');
    if(remain)remain.textContent=cart.total_price>=threshold?'Unlocked':`${money(threshold-cart.total_price)} away`;
    if(prog)prog.style.width=Math.min(100,(cart.total_price/threshold)*100)+'%';
    bindDrawer();
  }
  async function getCart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});return r.json();}
  async function refreshCart(){const cart=await getCart();renderCart(cart);return cart;}
  async function addItem(id, qty=1){
    try{
      const res=await fetch(window.routes.cart_add+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:qty}]})});
      if(!res.ok) throw new Error();
      await res.json(); showToast('Added to your bag'); await refreshCart(); openCart();
    }catch(e){showToast('Could not add this item. Please try again.');}
  }
  async function changeItem(key, quantity){
    try{const r=await fetch(window.routes.cart_change+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Number(quantity)})});if(!r.ok)throw new Error();renderCart(await r.json());}
    catch(e){showToast('Could not update your bag.');}
  }
  function bindDrawer(){
    $$('[data-drawer-minus]').forEach(b=>b.onclick=()=>changeItem(b.dataset.key,Math.max(0,Number(b.parentElement.querySelector('span').textContent)-1)));
    $$('[data-drawer-plus]').forEach(b=>b.onclick=()=>changeItem(b.dataset.key,Number(b.parentElement.querySelector('span').textContent)+1));
  }
  $$('[data-quick-add]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();b.dataset.quickView?location.href=b.dataset.quickView:addItem(b.dataset.quickAdd)}));
  const mobile=$('[data-mobile-drawer]');
  const mobOpen=()=>{mobile?.classList.add('is-open');mobile?.setAttribute('aria-hidden','false');document.body.classList.add('locked')};
  const mobClose=()=>{mobile?.classList.remove('is-open');mobile?.setAttribute('aria-hidden','true');document.body.classList.remove('locked')};
  $('[data-mobile-open]')?.addEventListener('click',mobOpen);$$('[data-mobile-close]').forEach(b=>b.addEventListener('click',mobClose));
  const filter=$('[data-filter-panel]');
  $('[data-filter-open]')?.addEventListener('click',()=>filter?.classList.add('is-open'));
  $('[data-filter-close]')?.addEventListener('click',()=>filter?.classList.remove('is-open'));
  $$('[data-qty-minus]').forEach(b=>b.onclick=()=>{const i=b.parentElement.querySelector('input');i.value=Math.max(1,Number(i.value)-1)});
  $$('[data-qty-plus]').forEach(b=>b.onclick=()=>{const i=b.parentElement.querySelector('input');i.value=Number(i.value)+1});
  // Product image carousel: arrows, thumbnail selection, and keyboard-friendly buttons.
  $$('[data-product-gallery]').forEach(gallery=>{
    const slides=$$('[data-gallery-slide]',gallery), thumbs=$$('[data-gallery-thumb]',gallery), count=$('[data-gallery-count]',gallery);
    if(!slides.length)return;
    let active=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
    const show=index=>{
      active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==active;slide.classList.toggle('is-active',i===active);});
      thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===active);thumb.setAttribute('aria-pressed',i===active?'true':'false');});
      if(count)count.textContent=`${active+1} / ${slides.length}`;
    };
    $('[data-gallery-prev]',gallery)?.addEventListener('click',()=>show(active-1));
    $('[data-gallery-next]',gallery)?.addEventListener('click',()=>show(active+1));
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    show(active);
  });

  // Option 2: accessible swipeable featured-product strip (no auto-advance).
  function initProductCarousels(){
    $$('[data-product-carousel]').forEach(carousel=>{
      if(carousel.dataset.carouselInitialized==='true')return;
      carousel.dataset.carouselInitialized='true';
      const track=$('[data-carousel-track]',carousel);
      const prev=$('[data-carousel-prev]',carousel);
      const next=$('[data-carousel-next]',carousel);
      if(!track||!prev||!next)return;
      const update=()=>{
        const maxScroll=Math.max(0,track.scrollWidth-track.clientWidth);
        const isStatic=maxScroll<4;
        carousel.toggleAttribute('data-carousel-static',isStatic);
        prev.disabled=isStatic||track.scrollLeft<=3;
        next.disabled=isStatic||track.scrollLeft>=maxScroll-3;
      };
      const step=direction=>{
        const slide=$('.akai-carousel-slide',track);
        const gap=parseFloat(getComputedStyle(track).columnGap)||16;
        const width=slide?slide.getBoundingClientRect().width+gap:track.clientWidth;
        const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({left:direction*width,behavior:reduced?'auto':'smooth'});
      };
      prev.addEventListener('click',()=>step(-1));
      next.addEventListener('click',()=>step(1));
      track.addEventListener('scroll',update,{passive:true});
      if('ResizeObserver' in window){new ResizeObserver(update).observe(track);}
      else window.addEventListener('resize',update,{passive:true});
      update();
      window.addEventListener('load',update,{once:true});
    });
  }
  initProductCarousels();
  document.addEventListener('shopify:section:load',initProductCarousels);

  const productForm=$('[data-product-form]');
  // Keep the hidden variant ID in sync with the selected option values.
  if(productForm){
    const variantData=$('[data-product-variants]');
    const variantInput=$('[data-variant-id]',productForm);
    const optionSelects=$$('[data-product-option]',productForm);
    const addButton=$('[data-add-to-bag]',productForm);
    let variants=[];
    try{variants=variantData?JSON.parse(variantData.textContent):[];}catch(e){}
    const syncVariant=()=>{
      if(!optionSelects.length||!variants.length)return;
      const selected=optionSelects.map(select=>select.value);
      const variant=variants.find(v=>v.options.every((value,i)=>value===selected[i]));
      if(variant&&variantInput){variantInput.value=variant.id; if(addButton){addButton.disabled=!variant.available;addButton.textContent=variant.available?'ADD TO BAG':'SOLD OUT';}}
    };
    optionSelects.forEach(select=>select.addEventListener('change',syncVariant));
    syncVariant();
    productForm.addEventListener('submit',async e=>{e.preventDefault();const fd=new FormData(productForm);await addItem(fd.get('id'),Math.max(1,Number(fd.get('quantity')||1)));});
  }
  const ann=$('[data-announcement]');
  if(ann && localStorage.getItem('akai-announcement-dismissed')!=='1'){
    const items=$$('.announcement__item',ann);let idx=0;
    if(items.length>1)setInterval(()=>{items[idx].style.opacity=0;items[idx].style.transform='translateY(-8px)';idx=(idx+1)%items.length;items[idx].style.opacity=1;items[idx].style.transform='none'},4500);
    $('[data-announcement-close]',ann)?.addEventListener('click',()=>{ann.style.display='none';localStorage.setItem('akai-announcement-dismissed','1')});
  }else if(ann)ann.style.display='none';
  bindDrawer();
})();
